import React from 'react';

import { DressCodeItemsFragment } from '../../generated/graphql';
import { dressCodeItemRoute } from '../../helpers/routes';
import { DressCodePageItemLink } from '../PageItemsRail/DressCodeItem/DressCodePageItemLink';
import { ItemProps } from './common';
import { useAttireCategories } from '../../hooks/useAttireCategories';
import { Caption } from '@xo-union/tk-ui-typography';
import { Item } from '../Card/subcomponents/Item';
import styles from './DressCode.module.scss';

// TODO: Add article and affiliates and refactor out
const StyledParagraphItem: React.FC<{
  header: string;
  typeLabel: string;
  description: string;
  className?: string;
  [key: string]: any;
}> = ({ header, typeLabel, description, className, ...rest }) => (
  <Item className={className} {...rest}>
    <div>
      <Caption className={styles.header}>{header}</Caption>
      <div>
        <Caption className={styles.typeLabel}>{typeLabel}</Caption>
        <Caption className={styles.description}>{description}</Caption>
      </div>
    </div>
  </Item>
);

const DressCode: React.FC<ItemProps> = ({ item, page, className, dragProps, preview }) => {
  const { id, attireCategoryId } = item as DressCodeItemsFragment;
  const { attireCategories } = useAttireCategories();

  const dressCodeOption = attireCategories.find(option => option.value === attireCategoryId);
  const dressCodeTypeLabel = dressCodeOption ? dressCodeOption.label : attireCategoryId || '';
  const dressCodeDescription = dressCodeOption ? dressCodeOption.description : '';
  const header = 'Dress Code';

  return (
    <DressCodePageItemLink
      to={dressCodeItemRoute(page.id, id, preview)}
      page={page}
      pageItem={item as DressCodeItemsFragment}
      data-testid={`dress-code-item-${id}`}
    >
      <StyledParagraphItem
        header={header}
        typeLabel={dressCodeTypeLabel}
        description={dressCodeDescription}
        className={styles.styledParagraphItem}
        {...dragProps}
      />
    </DressCodePageItemLink>
  );
};

export default DressCode;
